module.exports = __webpack_public_path__ + "img/Marketplace site map.dcec60e3.png";